document.addEventListener('DOMContentLoaded', () => {
    const $popupLinks = document.querySelectorAll('a.has-popup');

    $popupLinks.forEach($link => {
        $link.addEventListener('click', (event) => {
            event.preventDefault();

            const $popup = $link.querySelector('.popup');
            if ($popup) {
                $popup.classList.add('is-active');

                setTimeout(() => {
                    $popup.classList.remove('is-active');
                }, 2000);
            }
        });
    });
});
